/**
 * @desc 平台映射关系批量修改
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.LogisticsChannelPlatformDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsChannelPlatform/batchModify`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
